import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { merge, throwError as _throw } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';

import { DlgConfirmComponent } from './dlg-confirm.component';

interface IConfirmData {
    data: {
        title?: any;
        icon?: any;
        iconWidth?: any;
        iconHeight?: any;

        message?: any;
        innerHTML?: any;

        buttonsDirection?: 'reverse',

        buttonOkClasses?: string[];
        buttonOkLabel?: any;
        buttonOkInnerHTML?: string;
        buttonOkWarning?: any;

        buttonCancelClasses?: string[];
        buttonCancelLabel?: any;
        buttonCancelInnerHTML?: string;
    };
}

@Injectable()
export class ConfirmService {
    constructor(
        private _dialog: MatDialog,
    ) {
    }

    show({ data }: IConfirmData): Promise<any> {
        const dialogRef = this._dialog.open(DlgConfirmComponent, {
            panelClass: ['--ui'],
            data
        });

        const source = dialogRef.afterClosed();
        const success$ = source
            .pipe(filter<boolean>((val) => val));
        const error$ = source
            .pipe(filter((val) => !val))
            .pipe(switchMap((error) => _throw(`${ error }`)));

        return merge(success$, error$).toPromise();
    }
}
